import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

import * as couponVerification from '../../../../redux/healthboard/requests/coupon-verification-req';
import * as checkInReq from '../../../../redux/healthboard/requests/check-in-appointment-req';
import * as cancelReq from '../../../../redux/healthboard/requests/cancel-appointment-req';
import { appointmentDetailsActions } from '../../../../redux/healthboard/appointment-details';
import { selectVisitTestCallPerformed } from '../../../../redux/data/selectors';
import {
  selectCancelAppointmentPending,
  selectCheckInAppointmentPending,
  selectCouponAvailability,
  selectPaymentVerificationPending,
  selectPaymentGlobalLoader,
  selectManagePendingRequestSending,
} from '../../../../redux/healthboard/selectors';
import { VIRTUAL_VISIT_EVENTS } from '../../../../constants';
import { actions as managePendingRequestActions } from '../../../../redux/healthboard/requests/manage-pending-request';
import { appointmentConsentsModalActions } from '../../../../redux/healthboard/appointment-consent-modal';

const mapStateToProps = state => ({
  checkingPending: selectCheckInAppointmentPending(state),
  cancelPending: selectCancelAppointmentPending(state),
  paymentVerificationPending: selectPaymentVerificationPending(state),
  globalPaymentPending: selectPaymentGlobalLoader(state),
  isCouponAvailable: selectCouponAvailability(state),
  testCallPerformed: selectVisitTestCallPerformed(state),
  pendingManageReq: selectManagePendingRequestSending(state),
});
const mapDispatchToProps = {
  checkIn: checkInReq.actions.send,
  cancel: cancelReq.actions.send,
  verifyCoupon: couponVerification.actions.send,
  clearCouponVerification: couponVerification.actions.clear,
  changeStatus: appointmentDetailsActions.changeStatus,
  managePendingRequest: managePendingRequestActions.send,
  openConsentModal: appointmentConsentsModalActions.open,
};

export const enhance = compose(
  injectIntl,
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ changeStatus }) => ({
    noShowVisit: (id, appointment) => {
      changeStatus({
        event: VIRTUAL_VISIT_EVENTS.BREAK_VISIT,
        reason: 'no_show',
        appointment,
        id,
      });
    },
    completeVisit: (id, appointment) => {
      changeStatus({
        event: VIRTUAL_VISIT_EVENTS.FINISH_VISIT,
        appointment,
        id,
      });
    },
    cancelVirtualVisit: (id, appointment) => {
      changeStatus({
        event: VIRTUAL_VISIT_EVENTS.BREAK_VISIT,
        reason: 'canceled',
        appointment,
        id,
      });
    },
  })),
);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentDetailsPopup/enhance.js